export const INTENT_STATUS = {
    billed : 3,
    partiallyBilled : 4,
    completed: 10
};
